<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
        <v-row style="background:#fafafa;">
            <v-col cols="12" class="pa-0">
                <v-row class="py-1 px-5">
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12">
                                <v-card :loading="loading">
                                    <v-card-text class="py-0">
                                        <v-row class="align-center">
                                            <v-col cols="12" class="py-0">
                                                <v-card-text>
                                                    <ListFilter :i18n="i18n" @filter-applied="onFilterApplied" />
    
                                                    <v-row>
                                                        <v-col cols="4" md="4">
                                                    <v-btn color="success" :class="{'arFont': arabic, 'enFont': !arabic}" small @click="openAddDialog">{{ i18n['addPixel'] }}</v-btn>
    
                                                 </v-col>
                                            
                                                        <v-col cols="4" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
    
                                                               <v-btn color="success" block @click="videoDialog = true">{{i18n['intro_video']}}</v-btn>
                                                                <VideoDialog @close="closeVideoDialog" :dialog="videoDialog">
                                                                    <iframe width="100%" height="540"  src="https://www.youtube.com/embed/FedzfPNZEug?si=35Dj6OUhmA1fFU7T" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>  
                                                                </VideoDialog>
                                                        </v-col>
    
    
                                                    </v-row>
                                                    <!-- Add Pixel Dialog -->
    
                                                    <v-dialog v-model="addDialog" persistent max-width="600px">
                                                        <v-card>
                                                            <v-card-title>
                                                                {{ i18n['addPixel'] }}
                                                                <v-spacer></v-spacer>
                                                                <v-btn icon @click="closeAddDialog">
                                                                    <v-icon>mdi-close</v-icon>
                                                                </v-btn>
                                                            </v-card-title>
                                                            <v-card-text>
                                                                <v-form ref="addForm">
                                                                    <v-text-field outlined v-model="addFormData.pixel_identifier" :label="i18n['pixel']" :class="{'arFont': arabic, 'enFont': !arabic}"></v-text-field>
                                                                    <v-autocomplete outlined v-model="addFormData.platform_id" :items="platforms" item-text="name" item-value="id" :label="i18n['selectPlatform']" :class="{'arFont': arabic, 'enFont': !arabic}"></v-autocomplete>
                                                                </v-form>
                                                            </v-card-text>
                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="success" :class="{'arFont': arabic, 'enFont': !arabic}" @click="submitAdd">{{ i18n['save'] }}</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                    <!-- End Add Pixel Dialog -->
                                                    <v-dialog v-model="editDialog" persistent max-width="600px">
                                                        <v-card>
                                                            <v-card-title>
                                                                Edit Pixel
                                                                <v-spacer></v-spacer>
                                                                <v-btn icon @click="editDialog = false">
                                                                    <v-icon>mdi-close</v-icon>
                                                                </v-btn>
                                                            </v-card-title>
    
                                                            <v-card-text>
                                                                <v-container>
                                                                    <v-form ref="editForm">
                                                                        <v-text-field outlined v-model="selectedPixel.pixel_identifier" :label="i18n['pixel']" :class="{'arFont': arabic, 'enFont': !arabic}"></v-text-field>
                                                                        <v-autocomplete outlined v-model="selectedPixel.platform_id" :items="platforms" item-text="name" item-value="id" :label="i18n['selectPlatform']" :class="{'arFont': arabic, 'enFont': !arabic}">
                                                                        </v-autocomplete>
                                                                    </v-form>
                                                                </v-container>
                                                            </v-card-text>
    
                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="success" :class="{'arFont': arabic, 'enFont': !arabic}" @click="savePixel">{{ i18n['save'] }}</v-btn>
    
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
    
                                                    <v-row>
    
                                                        <v-col cols="12">
                                                                  
                                                            <div class="text-center my-3">
                                                                <v-btn color="success" :loading="loading" text small @click="reload()">{{i18n['reload']}}</v-btn>
                                                            </div>
    
                                                            <v-pagination v-model="currentPage" :length="totalPages" @input="fetchPixels"></v-pagination>
    
                                                            <v-simple-table>
                                                                <thead>
                                                                    <tr>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">ID</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{i18n['pixel']}}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">{{i18n['platform']}}</th>
                                                                        <th :class="`${arabic ? 'arFont' : 'enFont'}`">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="pixel in pixels" :key="pixel.id">
                                                                        <td>{{ pixel.id }}</td>
                                                                        <td>{{ pixel.pixel_identifier }}</td>
                                                                        <td>{{ pixel.platform.name }}</td>
                                                                        <td>
                                                                            <v-icon size="20" small class="mr-2" @click="editPixel(pixel)">
                                                                                mdi-pencil
                                                                            </v-icon>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </v-simple-table>
    
                                                            <v-pagination v-model="currentPage" :length="totalPages" @input="fetchPixels"></v-pagination>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
    </template>
    
        
    <script>
    //import axios from 'axios';
    import VideoDialog from '@/components/VideoDialog.vue';
    
    import ListFilter from '@/components/FormBuilder/ListFilterPixel.vue';
    
    export default {
        components: {
            ListFilter,VideoDialog,
        },
    
        data() {
            return {
                videoDialog:false,
                filterCriteria: {
                    inputSearch: '',
                    fromDate: '',
                    toDate: '',
                },
                addDialog: false,
                addFormData: {
                    pixel_identifier: '',
                    platform_id: null,
                },
                platforms: [],
            
                pixels: [],
                selectedPixel: {
                    id: null,
                    pixel_identifier: '',
                    platform_id: null,
                },
                editDialog: false,
    
                loading: false,
                currentPage: 1,
                totalPages: 0,
            };
        },
        methods: {
            closeVideoDialog(){
                this.videoDialog = false
            },
            resetAddFormData() {
                this.addFormData = {
                    pixel_identifier: '',
                    platform_id: null,
                };
            },
            async fetchPixels() {
                try {
                    this.loading=true;
                    const payload = {
                        resource: '/dataPixel',
                        value: {
                            filters:{
                                page: this.currentPage,
                                ...this.filterCriteria, 
                            }
                        }
                    };
                    const response = await this.$store.dispatch('getResource', payload);
                    this.pixels = response.data.data;
                    this.totalPages = response.data.last_page;
                //   console.log(this.pixels);
                } catch (error) {
                    console.error("Failed to fetch pixels:", error.response.data.data ? error.response.data.data : error);
                } finally {
                    this.loading = false; // Ensure loading indicator is turned off even in case of error
                }
            },
             async reload() {
              this.fetchPixels();
             },
            onFilterApplied(filterCriteria) {
                // Update filter criteria and fetch filtered pixels
                this.filterCriteria = filterCriteria;
                this.fetchPixels();
    
            },
            async submitAdd() {
                try {
                    this.loading=true;
    
                    const payload = {
                        resource: '/storePixel', 
                        value: this.addFormData
                    };
    
                    await this.$store.dispatch('postResource', payload);
    
                    this.fetchPixels();
                    this.resetAddFormData(); // Reset the form data
    
                    this.closeAddDialog();
                    this.addDialog = false;
                    this.loading=false;
    
                } catch (error) {
                    console.error("Failed to add new pixel:", error);
    
                    // Close the dialog
                    this.addDialog = false;
    
                    // Handle error
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                }
            },
            openAddDialog() {
                this.addDialog = true;
            },
            closeAddDialog() {
                this.addDialog = false;
            },
           async fetchPlatform() {
        try {
    
            const payload = {
                resource: '/getPlatform', 
            };
            const response = await this.$store.dispatch('getResource', payload);
    
            // Log the full response to understand its structure
            console.log('Full response:', response);
    
            // Check if response and response.data exist and have the expected structure
            if (response && response.data && Array.isArray(response.data)) {
                this.platforms = response.data;
            } else {
                console.error('Unexpected response structure:', response);
            }
        } catch (error) {
            console.error("Failed to fetch platforms:", error.response ? error.response.data : error);
        }
           },
            editPixel(pixel) {
                this.loading=true;
    
                this.selectedPixel = Object.assign({}, pixel); // Prepare for editing
                this.editDialog = true;
                this.loading=false;
    
            },
            async savePixel() {
        try {
            this.loading=true;
    
            const payload = {
                resource: `/updatePixel/${this.selectedPixel.id}`,
                value: this.selectedPixel
            };
            await this.$store.dispatch('putResource', payload);
            this.editDialog = false;
            this.fetchPixels();
            this.loading=false;
    
        } catch (error) {
            console.error("Failed to save pixel:", error.response ? error.response.data : error);
        }
           },
           closeVideoDialog(){
                this.videoDialog = false
            },
        },
        watch: {
    
            currentPage(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.fetchPixels();
                    this.fetchPlatform();
                }
            },
    
        },
        computed: {
    
            language() {
                return this.$store.state.language;
            },
            i18n() {
                return this.$store.state.i18n[this.language];
            },
            arabic() {
                return this.language === "ar";
            },
        },
        mounted() {
            this.fetchPixels();
        this.fetchPlatform(); 
        }
    }
    </script>
    